<template>
    <div class="register-page content-container">
        <div class="header">
            <div class="title">Register</div>
        </div>        
        <div class="content">
            <form @submit.prevent="register">

                <div class="edit-row">
                    <label for="email">E-Mail Address</label>                
                    <input id="email" type="email" v-model="email" required>                
                </div>
                <div class="edit-row">
                    <label for="displayName">Display Name</label>
                    <input id="displayName" type="text" v-model="displayName" required>
                </div>
                <div class="edit-row">
                    <label for="password">Password</label>    
                    <input id="password" type="password" v-model="password" required>
                </div>
                <div class="edit-row">
                    <label for="passwordConfirmation">Confirm Password</label>    
                    <input id="passwordConfirmation" type="password" v-model="passwordConfirmation" required>
                </div>
                <div class="right-aligned">
                    <span class="message">{{message}}</span>
                    <button type="submit">Register</button>
                </div>
            </form>
        </div>        
    </div>
</template>

<script>

    import common from '../../modules/common'

    export default {
        data() {
            return {
                email: "",
                displayName: "",
                password: "",
                passwordConfirmation: "",
                message: ""
            }
        },
        methods: {
            register: function () {
                let data = {
                    email: this.email,
                    displayName: this.displayName,
                    password: this.password,
                    passwordConfirmation: this.passwordConfirmation
                };
                this.$store
                    .dispatch("register", data)
                    .then(() => {
                      this.email = "";
                      this.displayName = "";
                      this.password = "";
                      this.passwordConfirmation = "";
                      this.message = "Please see the confirmation email."
                    });

            }
        },
        mounted() {
            var bc = common.breadcrumb.create([
                { url: '/', text: 'UtterAccess' },
                { url: '/register', text: 'Register' }
            ]);
            this.$store.dispatch("breadcrumb", bc);
        }
    }
</script>

